import { keyboardKey, SpacebarKey } from '../../keyboard-key';
import { IS_FOCUSABLE_ATTRIBUTE } from '../../attributes';
/**
 * @specification
 * Adds role='option'. This role is used for a selectable item in a list.
 * Adds attribute 'data-is-focusable=true' to 'root' slot.
 * Adds attribute 'aria-selected=true' based on the property 'selected'. Based on this screen readers will recognize the selected state of the item.
 * Triggers 'performClick' action with 'Enter' or 'Spacebar' on 'root'.
 */
export var selectableListItemBehavior = function selectableListItemBehavior(props) {
  var _root;
  return {
    attributes: {
      root: (_root = {
        role: 'option',
        'aria-selected': !!props.selected
      }, _root[IS_FOCUSABLE_ATTRIBUTE] = true, _root)
    },
    keyActions: {
      root: {
        performClick: {
          keyCombinations: [{
            keyCode: keyboardKey.Enter
          }, {
            keyCode: SpacebarKey
          }]
        }
      }
    }
  };
};
//# sourceMappingURL=selectableListItemBehavior.js.map
